<script>
import { GlobalPolicy } from '@/policies/global';
import { FormButton, PhoneNumber, SelectField, TextInput, UploadFiles } from '../form';
import Agent from '@/models/agent';

export default {
    setup() {
        return {
            GlobalPolicy,
            Agent
        }
    },
    data() {
        return {
            editing: false
        }
    },
    methods: {
        edit() {
            this.editing = JSON.parse(JSON.stringify(this.item));
        },
        cancel() {
            this.editing = false;
        },
        save() {
            if(!this.valid) {
                return
            }
            this.$emit('update', this.editing);
            this.cancel();
        }
    },
    computed: {
        photo_url: {
            get() {
                if(this.editing.photo_url) {
                    return [this.editing.photo_url]
                } else {
                    return this.editing.file == null ? [] : [this.editing.file]
                }
            },
            set(value) {
                this.editing.photo_url = null;
                this.editing.photo = null;
                this.editing.file = value[0];
            }
        },
        valid() {
            return this.editing.first_name &&
                this.editing.last_name &&
                this.editing.meta.phone
        }
    },
    emits: ['update'],
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    components: {
        FormButton,
        TextInput,
        SelectField,
        UploadFiles,
        PhoneNumber
    },
    created() {
        if(this.$route.path.includes('/edit') && GlobalPolicy.edit()) {
            this.edit();
        }
    }
}
</script>

<template>
    <div class="sticky top-0 bg-white flex flex-col lg:flex-row justify-between items-center py-4 -my-4">
        <h2 class="text-xl font-medium text-bhav-blue-600">Info</h2>
        <nav v-if="GlobalPolicy.edit()" class="flex items-end gap-2">
            <FormButton @click="edit()" v-if="!editing" color="blue" prefix-class="fak" icon="fa-pen">
                Edit
            </FormButton>
            <template v-else>
                <FormButton @click="cancel()" color="gray">
                    Cancel
                </FormButton>
                <FormButton :disabled="!valid" @click="save" color="blue">
                    Save
                </FormButton>
            </template>
        </nav>
    </div>
    <dl class="grid grid-cols-1 lg:grid-cols-4 mt-8" v-if="!editing">
        <dt class="text-sm leading-5 font-medium text-oakwood-gray-500 py-4">Email</dt>
        <dd class="text-sm leading-5 text-bhav-blue-500 lg:col-span-3 py-4">
            {{ item.email }}
        </dd>

        <dt class="text-sm leading-5 font-medium text-oakwood-gray-500 border-t border-t-oakwood-gray-100 py-4">Phone</dt>
        <dd class="text-sm leading-5 text-bhav-blue-500 lg:col-span-3 lg:border-t border-t-oakwood-gray-100 py-4">
            {{ item.meta.phone }}
        </dd>
    </dl>

    <form @submit="save" class="grid grid-cols-1 lg:grid-cols-4 mt-8" v-else>
        <legend class="sr-only">Agent Item Properties</legend>

        <input autocomplete="false" name="hidden" type="text" style="display:none;">

        <p class="text-sm leading-5 font-medium text-oakwood-gray-500 border-t border-t-oakwood-gray-100 py-4">
            Photo
        </p>
        <div class="text-sm leading-5 text-bhav-blue-500 lg:col-span-3 lg:border-t border-t-oakwood-gray-100 py-4">
            <UploadFiles v-model="photo_url" :multiple="false" class="col-span-2" />
        </div>

        <label for="first_name" class="text-sm leading-5 font-medium text-oakwood-gray-500 border-t border-t-oakwood-gray-100 py-4">
                First Name <span class="text-oakwood-red cursor-help" title="This field is required">*</span>
        </label>
        <div class="text-sm leading-5 text-bhav-blue-500 lg:col-span-3 lg:border-t border-t-oakwood-gray-100 py-4">
            <TextInput id="first_name" v-model="editing.first_name" />
        </div>

        <label for="last_name" class="text-sm leading-5 font-medium text-oakwood-gray-500 border-t border-t-oakwood-gray-100 py-4">
            Last Name <span class="text-oakwood-red cursor-help" title="This field is required">*</span>
        </label>
        <div class="text-sm leading-5 text-bhav-blue-500 lg:col-span-3 lg:border-t border-t-oakwood-gray-100 py-4">
            <TextInput id="last_name" v-model="editing.last_name" />
        </div>

        <label for="email" class="text-sm leading-5 font-medium text-oakwood-gray-500 border-t border-t-oakwood-gray-100 py-4">
            Email
        </label>
        <div class="text-sm leading-5 text-bhav-blue-500 lg:col-span-3 lg:border-t border-t-oakwood-gray-100 py-4">
            <TextInput id="email" v-model="editing.email"/>
        </div>

        <label for="phone" class="text-sm leading-5 font-medium text-oakwood-gray-500 border-t border-t-oakwood-gray-100 py-4">
            Phone <span class="text-oakwood-red cursor-help" title="This field is required">*</span>
        </label>
        <div class="text-sm leading-5 text-bhav-blue-500 lg:col-span-3 lg:border-t border-t-oakwood-gray-100 py-4">
            <PhoneNumber id="phone" v-model="editing.meta.phone" class="text-sm" />
        </div>
    </form>
</template>